// 设置cookie 默认30天有效
export function setCookie(name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie =
        name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

// 获取cookie
export function getCookie(name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
}

// 清除cookie
export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

//element: 执行动画的原生js dom元素
//className: animate样式名称
//leaveClassName: 元素离开页面时的animate样式名称，不传则元素动画只执行一次
//parentEle: 计算滚动距离的原生js dom元素，不传则默认为执行动画元素
//offsetDistance: 滚动距离调整，正数多滚动，负数少滚动
export function elementScroll(element, className, parentEle, leaveClassName, offsetDistance = 0) {
    element.style.opacity = 0
    window.addEventListener('scroll', function () {
        //页面滚动高度
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
        //计算相对位置的元素
        var ele = parentEle || element;
        //元素距离顶部高度
        var elementTopToTop = ele.offsetTop
        //浏览器视窗高度
        var screenH = document.documentElement.clientHeight
        //当元素出现在屏幕中
        if (elementTopToTop - scrollHeight >= 0 - offsetDistance && elementTopToTop - scrollHeight <= screenH - offsetDistance) {
            element.style.opacity = 1
            element.classList.remove(leaveClassName)
            element.classList.add(className)
        }
        //当元素离开屏幕
        else if (leaveClassName) {
            if (elementTopToTop - scrollHeight + element.offsetHeight < 0 + offsetDistance || elementTopToTop - scrollHeight > screenH - offsetDistance) {
                element.classList.remove(className)
                element.classList.add(leaveClassName)
            }
        }
    })
}

//	判断是IOS还是安卓
export function isIos() {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if (isiOS) {
        return true;
    } else if (isAndroid) {
        return false;
    }
}


//判断是移动设备还是PC
export function browserRedirect() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return 'mobile'
    } else {
        return 'pc'
    }
}

export function isPhone() {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
}